export const MOBILE_MEDIA_QUERY = '(max-width: 960px)';

export default {
  MOBILE_MEDIA_QUERY,
};
